/*!
 * AudoChat - Main App Component
 */

import { useState, useEffect } from "react";
import { Switch, Redirect, Route, useLocation } from "react-router-dom";
import auth from "utils/auth";

// Vision UI Dashboard React contexts
import { useVisionUIController, setMiniSidenav } from "context";

// Vision UI Dashboard React routes
import routes from "routes";

// Custom components
import AppTheme from "components/AppTheme";
import AppLayout from "components/AppLayout";
import getRoutes from "components/AppRoutes";
import Configurator from "examples/Configurator";

export default function App() {
  const [controller, dispatch] = useVisionUIController();
  const { direction, layout, miniSidenav } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  return (
    <AppTheme direction={direction}>
      {layout === "dashboard" && (
        <AppLayout
          onMouseEnter={handleOnMouseEnter}
          onMouseLeave={handleOnMouseLeave}
        />
      )}
      {layout === "vr" && <Configurator />}
      <Switch>
        {getRoutes(routes)}
        <Route exact path="/">
          {auth.isAuthenticated() ? (
            <Redirect to="/dashboard" />
          ) : (
            <Redirect to="/authentication/sign-in" />
          )}
        </Route>
        <Route path="*">
          {auth.isAuthenticated() ? (
            <Redirect to="/dashboard" />
          ) : (
            <Redirect to="/authentication/sign-in" />
          )}
        </Route>
      </Switch>
    </AppTheme>
  );
}
